import "bootstrap-icons/font/bootstrap-icons.css";

import { Link } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";

import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { Jumbotron } from "sections";
import { eligibility } from "constants/eligibility";
import { handleOpenPdf } from "utils";
import { ASSETS_BASE_URL } from "constants";
import ScrollAnimatedProgressBar from "components/progressbar/ScrollAnimatedProgressBar";

import pds from "assets/pdf/cards/PDS - Debit Card-i - 231222.pdf";
import form from "assets/pdf/cards/DebitATM-Card_Application_Form_161018.pdf";
import outline_check from "assets/images/outline_check.svg";
import debitcard from "assets/images/debitcard_table.svg";
import debitcard2 from "assets/images/debitcard_table_2.svg";
import Cards from "assets/images/hero-images/Banner_Cards.png";
import BG from "assets/images/hero-images/BG.png";

function DebitCard() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Cards"
          title={` <span className="jumbotron-subtitle-2">
                Debit
              </span>
              Card-<i>i </i><br>Convenience at
              <span className="jumbotron-subtitle-2">
                Zero Risk
              </span>`}
          buttonText="Talk to us"
          backgroundImage={Cards}
          uniqueBg={BG}
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>About</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Enjoy cashless convenience, whenever, and wherever you go. With an
              alrajhi bank Malaysia Debit Card-i, you can use the Visa-enabled
              card to pay online, over the phone and also use it for purchases
              at over 35 million Visa-accepted locations worldwide. Money will
              be subtracted straight from your account each time you make
              payments using the card. You will have convenient access to your
              funds via our ever-expanding network of ATMs and all other ATMs
              displaying the Visa PLUS and MEPS signs.
            </p>
          </div>
        </div>
      </section>
      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Benefits</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">VISA-enabled ATM Card</div>
                <div className="column-subheader-2">
                  Accepted for retail purchase @ 35 million retail outlets
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Ujrah contract</div>
                <div className="column-subheader-2">
                  A fee that will be charged to customer will be based on
                  Shariah contract
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Shariah standards</div>
                <div className="column-subheader-2">
                  Compliance with alrajhi bank Malaysia Shariah standards{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">ATM access</div>
                <div className="column-subheader-2">
                  The operating hours of all alrajhi bank ATMs nationwide are
                  from 06:00am- 11:59pm
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Eligibility</h3>
          </Col>
          <Col md={8}>
            <ScrollAnimatedProgressBar data={eligibility}>
              {eligibility.points.eligibilitydebit.description.map(
                (benefit, index) => (
                  <div className="animated-list z-1">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </ScrollAnimatedProgressBar>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div
          className="row"
          style={{ justifyContent: "flex-start", alignContent: "flex-start" }}
        >
          <div className="col-xl-4">
            <h3>Fees & Charges</h3>
          </div>
          <div className="col-xl-8">
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={`${ASSETS_BASE_URL}assets/images/tables/debitcardtable.svg`}
              className="d-inline-block align-top"
              alt=""
            />
            <img
              style={{
                width: "100%",
                alignSelf: "left",
                paddingBottom: "40px",
              }}
              src={debitcard2}
              className="d-inline-block align-top"
              alt=""
            />
            <div className="link-button-row">
              <Link to="/tnc" className="w-full">
                <LinkButton text="Terms and Conditions" />
              </Link>
              <LinkButton
                text="e-Application Form"
                onClick={() => handleOpenPdf(form)}
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() => handleOpenPdf(pds)}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Let's connect! </h3>
            <p>
              Share your information, and we'll get back to you with the answers
              you need.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default DebitCard;
